(() => {
  const key = 'everenoShowroomGallery';
  if (window[key]) {
    window[key].scan(document);
    return;
  }

  const bindings = new WeakMap();
  const roots = scope => {
    const found = Array.from(scope.querySelectorAll('[data-showroom-gallery]'));
    if (scope.matches?.('[data-showroom-gallery]')) found.unshift(scope);
    return found;
  };

  const bind = root => {
    if (bindings.has(root)) return;
    const dialog = root.querySelector('[data-gallery-dialog]');
    const image = root.querySelector('[data-gallery-image]');
    const caption = root.querySelector('[data-gallery-caption-output]');
    const viewport = root.querySelector('[data-gallery-viewport]');
    const closer = root.querySelector('[data-gallery-close]');
    const zoom = root.querySelector('[data-gallery-zoom]');
    if (!dialog?.showModal || !image || !caption || !viewport || !closer || !zoom) return;

    const controller = new AbortController();
    const options = { signal: controller.signal };
    let returnFocus = null;
    const updateZoom = () => {
      if (viewport.classList.contains('is-zoomed')) return;
      zoom.disabled = !image.naturalWidth || (image.naturalWidth <= viewport.clientWidth && image.naturalHeight <= viewport.clientHeight);
    };
    const setZoom = expanded => {
      viewport.classList.toggle('is-zoomed', expanded);
      zoom.setAttribute('aria-pressed', String(expanded));
      zoom.textContent = expanded ? zoom.dataset.labelFit : zoom.dataset.labelZoom;
      if (!expanded) {
        viewport.scrollTop = 0;
        viewport.scrollLeft = 0;
        updateZoom();
      }
    };
    const restoreFocus = () => {
      setZoom(false);
      if (returnFocus?.isConnected) returnFocus.focus({ preventScroll: true });
      returnFocus = null;
    };
    const close = () => {
      if (dialog.open) dialog.close();
    };

    root.addEventListener('click', event => {
      const opener = event.target.closest('[data-gallery-open]');
      if (!opener || !root.contains(opener) || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      if (!opener.dataset.galleryFull) return;
      event.preventDefault();
      if (dialog.open) return;
      returnFocus = opener;
      image.src = opener.dataset.galleryFull;
      image.alt = opener.dataset.galleryAlt || '';
      image.width = Number(opener.dataset.galleryWidth) || 1;
      image.height = Number(opener.dataset.galleryHeight) || 1;
      caption.textContent = opener.dataset.galleryCaption || '';
      caption.hidden = !caption.textContent;
      setZoom(false);
      dialog.showModal();
      updateZoom();
      closer.focus({ preventScroll: true });
    }, options);
    closer.addEventListener('click', close, options);
    zoom.addEventListener('click', () => setZoom(!viewport.classList.contains('is-zoomed')), options);
    image.addEventListener('load', updateZoom, options);
    image.addEventListener('error', () => { zoom.disabled = true; }, options);
    window.addEventListener('resize', updateZoom, options);
    dialog.addEventListener('close', restoreFocus, options);
    dialog.addEventListener('keydown', event => {
      if (event.key !== 'Tab') return;
      const controls = [closer, zoom, viewport].filter(control => !control.disabled);
      const first = controls[0];
      const last = controls[controls.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }, options);
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
    }, options);

    bindings.set(root, () => {
      close();
      restoreFocus();
      controller.abort();
      bindings.delete(root);
    });
  };
  const scan = scope => roots(scope).forEach(bind);
  window[key] = { scan };
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => roots(event.target).forEach(root => bindings.get(root)?.()));
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scan(document), { once: true });
  } else {
    scan(document);
  }
})();
